import { Paths } from "configs";

import { Notification } from "./Notification";

export const NotificationRoutes = [
  { path: Paths.notificationPath, element: <Notification /> },
];
